import React, { useState, useEffect } from "react";
import { Box, Modal, Button } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import mfa_call from "../../../assets/images/mfa_call.png";
import mfa_mail from "../../../assets/images/mfa_mail.png";
import AccessibleTooltip from "../../Tooltip/Tooltip";
import closeIcon from "../../../assets/images/closeicon.svg";
import mfa_shield from "../../../assets/images/mfa_shield.png";
import "./MFADialog.scss";
import AuthenticatorAppDialog from "../AuthenticatorAppDialog";
import MFALogin from "../MFALogin";
import EmailDialog from "../EmailDialog";
import { useDispatch, useSelector } from "react-redux";
import { setProgress } from "../../../Actions/progressActions";
import {
  sendEmailVerifyCode,
  authenticatorAppClick,
} from "../../../Actions/MFADialogAction";
import ProgressBar from "../ProgressBar";
import "../../../assets/styles/glButton.scss";
import {
  setRememberDeviceCheck,
  resetRememberDeviceState,
} from "../../../reducers/RememberDeviceReducer";
import PropTypes from "prop-types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
};
const styleBar = {
  marginTop: "20px",
};
const styleProgress = {
  justifyContent: "space-between",
  display: "flex",
  marginBottom: "8px",
};
const MFADialog = ({
  open,
  onClose,
  setCloseModalValidation,
  closeModalValidation,
}) => {
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const [mfaResponseData, setMfaResponseData] = useState();
  const [selectedMethod, setSelectedMethod] = useState("");
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const {
    sendEmailLoading,
    sendEmailSuccess,
    sendEmailError,
    authenticatorAppClickLoading,
    authenticatorAppClickData,
    authenticatorAppClickError,
  } = useSelector((state) => state.profile);
  const rememberDeviceCheck = useSelector(
    (state) => state.rememberDevice.rememberDeviceCheck
  );
  const progress = useSelector((state) => state.progress.progress);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setProgress(30));
  }, [dispatch]);

  const resetDialogState = () => {
    setSelectedMethod("");
    setEmailDialogOpen(false);
    setAuthDialogOpen(false);
    setLoginDialogOpen(false);
  };

  const handleClose = () => {
    onClose();
    resetDialogState();
    dispatch(resetRememberDeviceState());
  };

  const handleMethodSelection = (method) => {
    setSelectedMethod(method);
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const closeBtn = document.getElementById("MFA_closeIcon");
        closeBtn?.focus();
      }, 1500);
    }
  }, [open]);

  useEffect(() => {
    if (sendEmailLoading || authenticatorAppClickLoading) {
      resetDialogState();
    } else if (sendEmailSuccess) {
      setEmailDialogOpen(true);
    }

    if (authenticatorAppClickData) {
      const { mfaSetupStatus, secretImageUri } = authenticatorAppClickData;
      if (mfaSetupStatus === true) {
        setIsFirstLogin(false);
        setLoginDialogOpen(true);
      } else if (mfaSetupStatus === false) {
        setIsFirstLogin(true);
        setMfaResponseData(secretImageUri);
        setAuthDialogOpen(true);
      }
    }
  }, [
    sendEmailLoading,
    sendEmailSuccess,
    sendEmailError,
    authenticatorAppClickLoading,
    authenticatorAppClickData,
    authenticatorAppClickError,
  ]);

  const handleCancelDialog = () => {
    resetDialogState();
    dispatch(setProgress(30));
    dispatch(resetRememberDeviceState());
  };

  const handleNextClick = async () => {
    try {
      setCloseModalValidation(false);
      resetDialogState();

      if (selectedMethod === "email") {
        dispatch(sendEmailVerifyCode());
      } else if (selectedMethod === "authenticator") {
        dispatch(authenticatorAppClick());
      } else {
        console.warn("No valid verification method selected.");
      }
    } catch (error) {
      // console.error("Error preparing verification:", error);
    }
  };

  const handleCheckboxChange = (e) => {
    dispatch(setRememberDeviceCheck(e.target.checked));
  };

  const renderMethodButton = (icon, text, method, isDisabled = false) => (
    <li>
      <Button
        fullWidth
        disabled={isDisabled}
        className={`mfa-button ${selectedMethod === method ? "selected" : ""}`}
        style={{
          border: "1px dashed #5b5d75",
          marginBottom: "16px",
          backgroundColor: selectedMethod === method ? "#e6f7ff" : "inherit",
        }}
        onClick={() => !isDisabled && handleMethodSelection(method)}
        data-testid={
          method === "authenticator" ? "authenticator-btn" : undefined
        }

        aria-label={`${text} ${
          selectedMethod === "email" ? "selected" : ""
        }`}
        disableRipple
      >
        <div className="button-content">
          <img src={icon} alt="" className="button-icon" />
          <div className="button-text">{text}</div>
        </div>
      </Button>
    </li>
  );

  const renderDialog = () => {
    if (emailDialogOpen && !closeModalValidation) {
      return <EmailDialog onCancel={handleCancelDialog} />;
    }
    if (authDialogOpen && !closeModalValidation) {
      return (
        <AuthenticatorAppDialog
          barcode={mfaResponseData}
          isFirstLogin={isFirstLogin}
          onCancel={handleCancelDialog}
        />
      );
    }
    if (loginDialogOpen && !closeModalValidation) {
      return <MFALogin onCancel={handleCancelDialog} />;
    }

    return (
      <>
        <div className="dialog-content">
          <div className="dialog-space">
            <div className="dialog-description" id="mfa-dialog-description">
              <p>
                Prevent hackers from accessing your account with an additional
                layer of security. When you sign in, 2-Step verification helps
                ensure your personal information stays private, safe, and
                secure.
              </p>
              <p id="verficationMethod">
                Choose the preferred verification method.
              </p>
            </div>
          </div>
          <ul className="verfybuttons" aria-labelledby="verficationMethod">
            {/* {renderMethodButton(
                mfa_call,
                "Verification by Phone/SMS",
                "phone",
                true
              )} */}
            {renderMethodButton(mfa_mail, "Verification by Email", "email")}
            {renderMethodButton(
              mfa_shield,
              "Verification by Authenticator App",
              "authenticator"
            )}
          </ul>
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="rememberDeviceCheck"
              checked={rememberDeviceCheck}
              onChange={handleCheckboxChange}
              className="check"
              aria-describedby="rememberDeviceDescription"
            />
              <label htmlFor="rememberDeviceCheck" className="rem-text" >
              Remember this device
            </label>
            {/* <span id="rememberDeviceDescription" class="visually-hidden">
              Select this to skip MFA verification on this device in future
              logins.
            </span> */}
          
          </div>
        </div>

        <div className="mfa-save">
          <Button
            variant="outlined"
            className="cancelBtn"
            onClick={handleClose}
            disableRipple
          >
            Cancel
          </Button>
          <button
            onClick={handleNextClick}
            style={{ marginRight: "32px" }}
            className="containedButton"
            data-testid="next-btn"
            disableRipple
            disabled={!selectedMethod}
          >
            Next
          </button>
        </div>
      </>
    );
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleCancelDialog();
        onClose();
      }}
      className="addFlorModal"
    >
      <div role="none">
        <Box
          sx={style}
          className="mfaGlobalbox"
          role="dialog"
          aria-modal="true"
          aria-labelledby="mfa-dialog-title"
        >
          <div className="" style={styleBar}>
            <div style={styleProgress}>
              <span className="progress-text" aria-hidden="true">
                Login Progress ({progress}%)
              </span>
              <AccessibleTooltip title="Close">
                <button
                  onClick={() => {
                    onClose();
                    dispatch(setProgress(30));
                    dispatch(resetRememberDeviceState());
                  }}
                  className="icon-container"
                  aria-label="close"
                  id="MFA_closeIcon"
                >
                  <img src={closeIcon} alt="" aria-hidden="true" />
                </button>
              </AccessibleTooltip>
            </div>
            <div aria-label={`Login Progress ${progress} percent`} role="img">
              <ProgressBar />
            </div>
          </div>
          <div className="dialog-title">
            <h2 id="mfa-dialog-title" className="dialog-title-text">
              Multi-Factor Authentication
            </h2>
          </div>
          {renderDialog()}
        </Box>
      </div>
    </Modal>
  );
};

MFADialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  setCloseModalValidation: PropTypes.func.isRequired,
  closeModalValidation: PropTypes.bool.isRequired,
};

export default MFADialog;
